import {FC} from "react";
import {EmployeesDialog} from "../employees/EmployeesDialog";
import {useAppDispatch, useAppSelector} from "../../hooks";
import {
    selectEmployeesPopupVisible, selectLogisticsPopupVisible,
    setEmployeesPopupVisible,
    setLogisticsPopupVisible
} from "../../../features/AppStateSlice";
import {TrucksDialog} from "../trucks/TrucksDialog";

const TrucksPopup: FC = () => {
    const dispatch = useAppDispatch();
    const isVisible = useAppSelector(selectLogisticsPopupVisible);

    return (
        <TrucksDialog zIndex={1100} show={isVisible}
                         onClose={() => dispatch(setLogisticsPopupVisible(false))} />
    );
}

export default TrucksPopup;
